import { Field, FieldProps } from 'formik';
import { get } from 'lodash';
import { ChangeEvent, useEffect } from 'react';

import { DatePicker } from 'targets/web/components';
import { localTimeToUTC, utcToLocalTime } from 'targets/web/modules/jobs/utils';

export const FormikDatePicker = ({
  resetOnUnmount = false,
  ...props
}: {
  resetOnUnmount?: boolean;
  onChange?: (value: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  disabled?: boolean;
  [x: string]: unknown;
}) => {
  return (
    <Field name={props.name} required={props.required}>
      {({ field, form: { touched, errors, setFieldValue } }: FieldProps) => {
        // To support dynamic fields
        // https://github.com/jaredpalmer/formik/issues/1173
        useEffect(() => {
          if (typeof resetOnUnmount === 'boolean' && !resetOnUnmount) {
            return;
          }

          return () => {
            setFieldValue(field.name, undefined, false);
          };
        }, [field.name, setFieldValue]);

        const hasError = !!get(errors, field.name) && !!get(touched, field.name);

        return (
          <DatePicker
            {...field}
            data-testid={props.name}
            error={hasError}
            helperText={hasError ? get(errors, field.name)?.toString() : undefined}
            {...props}
            value={field.value ? utcToLocalTime(new Date(field.value)) : null}
            disabled={props.disabled}
            onChange={(e) => setFieldValue(field.name, e ? localTimeToUTC(e) : undefined)}
          />
        );
      }}
    </Field>
  );
};
